import { fadeInAnimationLong, fadeInAnimationShort, styles } from 'consts';
import styled from 'styled-components';

const { animationLong, animationShort, white, primaryBlack, blueSecondary, fontMBank } = styles;

export const AbandonedScreenContainer = styled.div<{ isLoading: boolean; height: number }>`
  border-radius: 0.5rem;
  background: ${white};
  text-align: center;
  color: ${white};
  padding: 3.3125rem;

  ${props =>
    props.isLoading &&
    ` padding: 0;
      height: ${props.height}px;
  `}
`;

export const AbandonedScreenWrapper = styled.div`
  animation: ${animationShort};
  ${fadeInAnimationShort};

  .abandoned-screen__button {
    overflow: visible;
  }
`;

export const AbandonedScreenStatus = styled.div`
  font-size: 2rem;
  line-height: 1.25;
  text-align: center;
  color: ${primaryBlack};
  max-width: 25rem;
  margin: 0 auto;
`;

export const AbandonedScreenStatusText = styled.div`
  font-size: 2rem;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: ${blueSecondary};
  margin-bottom: 1.5rem;
  max-width: 25rem;
  margin: 0 auto;
`;

export const AbandonedScreenIcon = styled.div`
  animation: ${animationLong};
  ${fadeInAnimationLong};
  img {
    width: 12.5rem;
    height: 9.375rem;
  }
  margin-bottom: 0.5rem;
`;

export const AbandonedScreenMessage = styled.div`
  color: ${primaryBlack};
  font-family: ${fontMBank};
  font-size: 1.375rem;
  line-height: 1.32;
  max-width: 30rem;
  margin: 0 auto;
`;

export const AbandonedScreenBackToShopButton = styled.button`
  position: relative;
  display: inline-block;
  border-radius: 0.6875rem;
  border-radius: 0.6875rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.125rem;
  text-transform: uppercase;
  font-family: ${fontMBank};
  outline: none;
  cursor: pointer;
  white-space: nowrap;
  padding: 0.625rem;
  width: 40%;
  height: 2.5rem;
  overflow: unset;
  color: #da1600;
  background-color: #ffffff;

  @media (max-width: 768px) {
    margin-top: 0.625rem;
    display: block;
    padding: 0;
    width: 100%;
  }
`;

export const AbandonedScreenButtonWrapper = styled.div`
  margin-top: 2rem;
`;
